import axios from "axios";

const { REACT_APP_MY_ENV } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_MY_ENV,
});

export function getReferralAllStatus() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/referral/all",

      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getReferralInvitation() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/referral/invitation",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => resolve(response.data))
      .catch(reject);
  });
}
